import { render } from "./SubAccountMIInvestmentsCard.vue?vue&type=template&id=2a4e2767&scoped=true"
import script from "./SubAccountMIInvestmentsCard.vue?vue&type=script&lang=js"
export * from "./SubAccountMIInvestmentsCard.vue?vue&type=script&lang=js"

import "./SubAccountMIInvestmentsCard.vue?vue&type=style&index=0&id=2a4e2767&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a4e2767"

export default script